import {Component, OnInit} from '@angular/core';
import {FormModel, FormTypes} from "../../shared/forms/models/constants";
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FormElementComponent} from "../../shared/forms/form-element/form-element.component";
import {InputSwitchModule} from "primeng/inputswitch";
import {TranslateModule} from "@ngx-translate/core";
import {Button} from "primeng/button";
import {CalendarModule} from "primeng/calendar";
import {FileUploadEvent, FileUploadModule} from "primeng/fileupload";
import {NgForOf, NgIf} from "@angular/common";
import {MessageService} from "primeng/api";
import {EditorModule} from 'primeng/editor';
import {InputGroupModule} from "primeng/inputgroup";
import {InputGroupAddonModule} from "primeng/inputgroupaddon";
import {InputTextModule} from "primeng/inputtext";
import {HttpClient, HttpClientModule} from "@angular/common/http";

interface UploadEvent {
    originalEvent: Event;
    files: File[];
}

@Component({
    selector: 'app-task-form',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        FormElementComponent,
        InputSwitchModule,
        TranslateModule,
        Button,
        CalendarModule,
        FormsModule,
        FileUploadModule,
        NgIf,
        NgForOf,
        EditorModule,
        InputGroupModule,
        InputGroupAddonModule,
        InputTextModule,
    ],
    providers: [
        MessageService,
        HttpClientModule
    ],
    templateUrl: './task-form.component.html',
    styleUrl: './task-form.component.scss'
})
export class TaskFormComponent implements OnInit {

    mockApiUrl: string = 'assets/task/mock-api.json';

    uploadedFiles: any[] = [];

    protected readonly FormTypes = FormTypes;
    formGroup: FormGroup = new FormGroup({
        project: new FormControl(''),
        taskState: new FormControl(''),
        targetDate: new FormControl(''),
        sendForm: new FormControl(''),
        priority: new FormControl('MEDIUM'),
        recurring: new FormControl<number>(0),
        recurringPeriod: new FormControl('Days(s)'),
        reminder: new FormControl<number>(0),
        reminderPeriod: new FormControl('Days(s)'),
        sendToRecipient: new FormControl<boolean>(false),
        title: new FormControl(''),
        taskDescription: new FormControl(''),
        acceptanceInfo: new FormControl(''),
        sendToGroup: new FormControl<boolean>(false),
        responsiblePerson: new FormControl(''),
        responsibleGroup: new FormControl('')
    })
    projectValues: FormModel[] | undefined;
    timePeriods: FormModel[] | undefined;

    constructor(private messageService: MessageService, private http: HttpClient) {
    }

    ngOnInit() {

        this.http.get<any>(this.mockApiUrl).subscribe((res) => {
            this.projectValues = res.projects;
        })

        this.timePeriods = [
            {
                value: 'hour',
                label: 'Hour(s)',
            },
            {
                value: 'day',
                label: 'Day(s)',
            },
            {
                value: 'week',
                label: 'Week(s)',
            },
            {
                value: 'month',
                label: 'Month(s)',
            },
            {
                value: 'year',
                label: 'Year(s)',
            }
        ]

    }

    toggleSelection(param: any) {
        param.isSelected = !param.isSelected;
    }

    confirmForm() {
        console.log(this.formGroup.value);
        this.formGroup.reset()
    }

    onUpload(event: FileUploadEvent) {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
        }

        this.messageService?.add({severity: 'info', summary: 'File Uploaded', detail: ''});
    }

    protected readonly FormGroup = FormGroup;
}
